export class GetMemberDiscountsRequest {
    constructor(fromSearch: number, statusSearch: number, searchText: string){
        this.fromSearch = fromSearch;
        this.statusSearch = statusSearch;
        this.searchText = searchText;
    }
    fromSearch: number;
    statusSearch: number;
    searchText: string;
}
